import { css } from 'styled-components';

export interface LinkStylesProps {
  $matchColor?: boolean;
}

/** @deprecated prefer import { Link } from '@workramp/ui'; */
export const linkStyles = css<LinkStylesProps>`
  color: ${({ theme, $matchColor }) => ($matchColor ? 'currentColor' : theme.colors.primary[600])};
  transition: ${({ theme }) => `color ${theme.motion.duration.short}ms ease-in-out`};

  &:link,
  &:visited {
    color: ${({ theme, $matchColor }) => ($matchColor ? 'currentColor' : theme.colors.primary[600])};
    text-decoration: none;
  }

  &:hover,
  &:focus {
    color: ${({ theme, $matchColor }) => ($matchColor ? theme.colors.primary[600] : theme.colors.primary[700])};
    text-decoration: none;
  }
`;
